export default {
    PRODUCER: import.meta.env.VITE_PRODUCER_ROLE_ID,
    ESTABLISHMENT: import.meta.env.VITE_ESTABLISHMENT_ROLE_ID,
    ADMIN: import.meta.env.VITE_ADMIN_ROLE_ID,
    USER: import.meta.env.VITE_USER_ROLE_ID,
}